import { Link } from "gatsby"
import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import logo from "../assets/images/logo-white.png"
import {
  FaFacebookSquare,
  FaInstagram,
  FaPhoneSquareAlt,
  FaSms,
} from "react-icons/fa"

const Footer = () => {
  return (
    <footer>
      <Container className="p-4">
        <Row>
          <Col lg={4}>
            <Link to="/">
              <img src={logo} alt="logo" className="logo footer-logo" />
            </Link>
            <div className="footer-c">
              <a href="https://www.instagram.com/undorm">
                <FaInstagram className="social-icon2" />
              </a>
              <a href="https://www.facebook.com/undorm/">
                <FaFacebookSquare className="social-icon2" />
              </a>
              <a href="tel:(702) 339-1414">
                <FaPhoneSquareAlt className="social-icon2" />
              </a>
              <a href="sms:/(702) 339-1414/?body=/hello/">
                <FaSms className="social-icon2" />
              </a>
            </div>
          </Col>
          <Col lg={2} xs={6}>
            <h1 className="h5 fw-bold my-4">Undorm</h1>
            <Link to="/">
              <p>Home</p>
            </Link>
            <Link to="/about">
              <p>About</p>
            </Link>
            <Link to="/faq">
              <p>FAQ</p>
            </Link>
            <Link to="/blog">
              <p>Blog</p>
            </Link>
          </Col>
          <Col lg={2} xs={6} className="f-left">
            <h1 className="h5 fw-bold my-4">For Students</h1>
            <Link to="/finding-place">
              <p>I'm Finding an Apartment</p>
            </Link>
            <Link to="/listing-place">
              <p>I'm Listing an Apartment</p>
            </Link>
            <h1 className="h5 fw-bold">For Guarantors</h1>
            <Link to="/for-guarantors">
              <p>Overview</p>
            </Link>
          </Col>
          <Col lg={2} xs={6}>
            <h1 className="h5 fw-bold my-4">Marketplace</h1>
            <Link to="/">
              <p>View Listings</p>
            </Link>
            <Link to="/">
              <p>Add Listings</p>
            </Link>
            <Link to="/">
              <p>Account</p>
            </Link>
          </Col>
          <Col lg={2} xs={6}>
            <h1 className="h5 fw-bold my-4">Support</h1>
            <p>support@undorm.com</p>
            <p>Call or Text: (702) 339-1414</p>
            <a href="https://www.instagram.com/undorm/">
              <p>Instagram DM us @undorm</p>
            </a>
          </Col>
        </Row>
        <div className="bt my-3">
          <div className="d-lg-flex d-block justify-content-between align-items-center add-det mt-4">
            <p>
              Copyright © {new Date().getFullYear()} - Undorm.com All Rights
              Reserved by Undorm Partners LLC
            </p>
            <p>Privacy and Terms</p>
          </div>
        </div>
      </Container>
    </footer>
  )
}

export default Footer
